export const configData = {
  maximumNumberOfCurrentOrdersPerUser: 100,
  imagesBaseURLs: {
    menu: "https://images.waseat.albaikcloud.com/",
    branches: "https://images.waseat.albaikcloud.com/",
  },
  orderModes: {
    pickupMode: "Pickup",
    deliveryMode: "Delivery",
    driveThruMode: "DriveThru",
    onlineDriveThruMode: "OnlineDriveThru",
  },
  aggregators: [
    {
      code: "Careem",
      name: "Careem Now",
      image: "https://images.staging.waseat.albaikcloud.com/careem_now.jpg",
    },
    {
      code: "Wssel",
      name: "Wssel",
      image: "https://images.staging.waseat.albaikcloud.com/wssel.jpg",
    },
    {
      code: "ToYou",
      name: "To You",
      image: "https://images.staging.waseat.albaikcloud.com/to_you.jpg",
    },
    {
      code: "Jahez",
      name: "Jahez",
      image: "https://images.staging.waseat.albaikcloud.com/jahez.jpg",
    },
  ],
  tenderID: {
    Pickup: 19,
    Delivery: 37,
  },
  reachableBranchesRadius: 50,
  itemsFilters: [
    {
      category: "breakfast",
      name: {
        ar: "فطور",
        en: "Breakfast",
      },
    },
    {
      category: "chicken",
      name: {
        ar: "دجاج",
        en: "Chicken",
      },
    },
    {
      category: "seafood",
      name: {
        ar: "مأكولات بحرية",
        en: "Seafood",
      },
    },
    {
      category: "vegetarian",
      name: {
        ar: "نباتي",
        en: "Vegetarian",
      },
    },
    {
      category: "side",
      name: {
        ar: "طلبات جانبية",
        en: "Sides",
      },
    },
    {
      category: "dessert",
      name: {
        ar: "حلويات",
        en: "Desserts",
      },
    },
    {
      category: "beverage",
      name: {
        ar: "مشروبات",
        en: "Beverages",
      },
    },
  ],
  tposFilters: [
    {
      category: "plate",
      name: {
        en: "Plates",
      },
    },
    {
      category: "sandwich",
      name: {
        en: "Sandwiches",
      },
    },
    {
      category: "extra",
      name: {
        en: "Sides \u0026 Extras",
      },
    },
    {
      category: "beverage",
      name: {
        en: "Beverages",
      },
    },
  ],
  nutritionalInformationTranslations: {
    weight: {
      en: "Weight",
      ar: "الوزن",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    cal: {
      en: "Calories",
      ar: "السعرات حرارية",
      unit: {
        ar: "سعرة حرارية",
        en: "kcal",
      },
    },
    cho: {
      en: "Carbohydrate",
      ar: "الكربوهيدرات",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    sugars: {
      en: "Sugars",
      ar: "السكريات",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    fibre: {
      en: "Fibre",
      ar: "الألياف",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    protein: {
      en: "Protein",
      ar: "بروتين",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    total_fat: {
      en: "Total Fats",
      ar: "إجمالي الدهون",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    saturated_fat: {
      en: "Saturated Fats",
      ar: "الدهون المشبعة",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    trans_fat: {
      en: "Trans Fats",
      ar: "الدهون الغير المشبعة",
      unit: {
        ar: "جم",
        en: "g",
      },
    },
    cholesterol: {
      en: "Cholesterol",
      ar: "الكوليسترول",
      unit: {
        ar: "ميلي جم",
        en: "mg",
      },
    },
    sodium: {
      en: "Sodium",
      ar: "الصوديوم",
      unit: {
        ar: "ميلي جم",
        en: "mg",
      },
    },
    Gluten: {
      en: "Gluten",
      ar: "الجلوتين",
    },
    Sesame: {
      en: "Sesame",
      ar: "بذور السمسم",
    },
    Soy: {
      en: "Soy",
      ar: "فول الصويا",
    },
    Milk: {
      en: "Milk",
      ar: "الحليب",
    },
    Egg: {
      en: "Egg",
      ar: "البيض",
    },
    Mustard: {
      en: "Mustard",
      ar: "الخردل",
    },
    Fish: {
      en: "Fish",
      ar: "السمك",
    },
    Shellfish: {
      en: "Shellfish",
      ar: "القشريات",
    },
  },
  featureFlags: {
    enablePickupInDriveThru: true,
    enableHeroSection: true,
    enableNationalDayCampaign: true,
    enablePickupOrders: false,
    enableLaunchPopup: true,
    enableReplacementPaymentGateway: false,
    enableAccountDeletion: true,
    enableKafkaDriverAssignment: true,
    enableServiceScreenFifoValidation: false,
    enableKafkaDriverReassignment: true,
    enableKafkaDriverCollecting: true,
    enableWaitingBays: true,
    driverCoreTripAssignment: true,
    driveThruLaneAssignmentBasedOnOrders: false,
    stackedOrders: true,
    paymentScreenOpensGate: false,
    enforceUserAgentOnGraphQL: true,
    enableInternationalOrders: true,
    enableInternationalPhoneNumber: true,
    enableDeliveryEstimationTimePopup: false,
    pickupNotification: true,
    onlineLane: true,
    enableTripAssignmentCandidateCheck: true,
    enablePickupFromDriveThru: true,
    applePay: true,
    sendOrdersToFulfillmentService: false,
    driver_schedule: true,
    itemCustomizations: true,
    showDropdownfiltersInAdminOrderIndex: true,
    markDeliveredButton: true,
    onlineBaikThru: false,
    enableInternationalPickupOrdersForBH: false,
    adminOrdersIndexUseReadReplica: true,
    quickReorderFeature: true,
    itemCustomizationsCountries: true,
    favoriteOrderFeature: true,
    autoRemoveFromStack: false,
    stackedOrdersDebug: true,
    driver_order_history: true,
    allergensFeature: true,
    orderReceiptWithVAT: true,
    pickupCustomerArrivalFlow: true,
    upsellingFeature: true,
    enableStcpayFeature: true,
    itemCustomizationsProducts: false,
    enableOrderRatings: true,
    enableOrderFeedback: true,
    unifonicApi2023: true,
    show_dashboard_link: true,
    cookedItemsBasedEpt: false,
    lastRestaurantRecentlyOrderedFrom: true,
    savedLocations: true,
    enableAreaAlerts: false,
    restaurantDashboardGamification: false,
    enableBasketVibration: true,
    busyRestaurantEpt: false,
    driverQueue: true,
    markOrderAsPrepared: true,
    driverProximityNotification: false,
    useArchiveOrders: true,
    menusPerBranch: false,
    groupOrders: true,
    enableInStoreOrdering: true,
    enableBaikeezCustomizations: false,
    checkinPercentage: true,
    disableServedButton: true,
    enableDynamicHero: true,
    adminOrdersOutOfStock: true,
    largeOrderFilter: true,
    enableCustomerArrivalManually: true,
    deliveryAreaMenu: true,
    enableSystemStatusPage: true,
    useTotalsBasedPreparationTimeForInStoreOrdering: false,
    enableWastageTimer: true,
    useFixedPreparationTimeForNonCookedItemsForInStoreOrdering: true,
    enableScanToCompletePickup: true,
    enableHeroItemCategories: true,
    adminVehicleTypes: true,
    showSosNumber: true,
    unsuitableBranchFiltering: true,
    fetchCheckIdSidekiq: true,
    allowAutomaticOrderRefund: true,
    adminOTP: false,
    orderRefundNotification: true,
    stackedOrdersOnlyWithCarVehicleType: true,
    adminVehicleTypesWithDriverCapacity: true,
    updateDeliveryAreaVehicleTypes: true,
    enableInternationalPickupOrdersForAE: false,
    checkoutGatewayForCards: true,
    authActivity: true,
    conditionalJoinAdminOrders: false,
    enableDynamicCombo: true,
    showEptForInStoreOrdering: true,
    enableReceiptItemGrouping: true,
    enableCurbside: true,
    useNewDriverQueueLogic: true,
    checkoutGatewayForApplePay: true,
    enableNewOrdersFilter: true,
    customerLoginOTP: false,
    restaurantPanelFiltersAndMultiplePrinters: false,
    sendOrdersDirectlyToFulfillment: false,
    driverLoginOTP: false,
    posSettledTime: true,
    enableDynamicFavoriteList: true,
    cancel_by_source_id: true,
    processNewOrderAsync: true,
    preventTransferToDifferentLicensee: false,
    enableNewPickupDesign: true,
    otpExempt: false,
    enableInStoreOrderingInUAE: true,
    enableEditOrderButton: true,
    orderFullyRefundNotification: true,
    enableNewDeliveryDesign: true,
    useCoreDataClientForSyncLicensee: true,
    useCoreDataClientForSyncMenuItems: false,
    useCoreDataClientForSyncBranches: true,
    useCoreDataClientForSyncProducts: true,
    multipleLicensees: false,
    enableNewInstoreDesign: true,
    enableNewCurbsideDesign: true,
    enableHideDriverPhone: false,
    menuPerCity: false,
    checkoutcom_verbose_logging: true,
    allowPickupTransfer: true,
    enableMitForCheckoutGateway: false,
    useVoidRefundForCheckout: true,
    hyperpay_verbose_logging: true,
    enableCustomerPersonalQuestions: true,
  },
  adminConfiguration: {
    mapViewUpdateFrequency: 30,
    driverDistanceFromBranchMeters: 1500,
    pickupGracePeriodSeconds: 0,
    itemCustomizationsCountries: ["SA", "BH", "AE"],
    customerDistanceFromBranchMeters: 10000000000,
    orderBasketTotal: 200000,
  },
};
